import React, { PropsWithChildren } from "react";

type Props = {
  id: string;
  checked: boolean;
  title: string;
  isActive?: boolean;
  amountChecked: number;
};

export const FilterSortDrawerItem: React.FC<PropsWithChildren<Props>> = ({
  id,
  title,
  checked,
  children,
  isActive,
  amountChecked
}) => {
  return (
    <li className={`ac ${isActive ? "is-active" : ""}`}>
      <h3 className="ac-header">
        <button type="button" className="ac-trigger h3" data-slidetoggle={`#rs_box-${id}`}>
          <span className="text-lg filter-sort-drawer__rs_filter__title">
            {checked && <ui-icon name="icon-check-large" width="16" height="16"></ui-icon>}
            {title}
            {amountChecked > 0 ? ` (${amountChecked})` : ''}
          </span>
          <ui-icon name="icon-chevron-down-large"></ui-icon>
        </button>
      </h3>
      <div className="ac-panel" id={`rs_box-${id}`} style={{ height: isActive ? "auto" : undefined }}>
        {children}
      </div>
    </li>
)};
